const COUPON_TYPE_AMOUNT = 'amount'; // cupon por monto
const COUPON_TYPE_PERCENTAGE = 'percentage'; // cupon por porcentaje

module.exports = {
  COUPON_TYPE_AMOUNT,
  COUPON_TYPE_PERCENTAGE,
};
